(function (root, factory) {
  var api = factory();
  if (typeof module === "object" && module.exports) module.exports = api;
  if (root) root.AOBuilderCore = api;
})(typeof window !== "undefined" ? window : this, function () {
  "use strict";

  var KEYS = {
    first: "firstLocation",
    additional: "additionalLocation",
    background: "paintedBackground",
    logo: "logoTile",
    customLogo: "customLogoTile",
    direction: "directionTile",
    small_mailbox: "smallMailboxTiles",
    plaque: "housePlaque",
  };

  function product(products, key) {
    var p = products[KEYS[key] || key];
    if (!p || !p.id || !Number.isInteger(p.price)) throw new Error("Missing product: " + key);
    return p;
  }

  function baseKey(set, index) {
    if (index === 0) return "first";
    if (set.location.kind === "plaque") return "plaque";
    if (set.location.kind === "small_mailbox") return "small_mailbox";
    return "additional";
  }

  var MAX_LOGO_QTY = 4;

  function logoType(slot) {
    return slot && slot.type && slot.type !== "none" ? slot.type : null;
  }

  // How many identical logo tiles sit on this side of the number.
  function logoQty(slot) {
    if (!logoType(slot)) return 0;
    var qty = parseInt(slot.qty, 10);
    return Math.min(MAX_LOGO_QTY, Math.max(1, qty || 1));
  }

  function times(qty) {
    return qty > 1 ? " × " + qty : "";
  }

  function slotLabel(slot) {
    if (logoType(slot) !== "custom") return slot.name;
    return slot.name ? "Custom logo (" + slot.name + ")" : "Custom logo";
  }

  function tileLayout(set) {
    var out = [];
    function logos(slot) {
      for (var n = 0; n < logoQty(slot); n++) out.push("[" + slotLabel(slot) + "]");
    }
    if (set.location.allow_logos) logos(set.left);
    String(set.number || "")
      .split("")
      .forEach(function (digit) {
        out.push(digit);
      });
    if (set.location.allow_direction && set.direction) out.push(set.direction);
    if (set.location.allow_logos) logos(set.right);
    return out.join(" ");
  }

  function tileCount(set) {
    return (
      String(set.number || "").length +
      (set.location.allow_logos ? logoQty(set.left) + logoQty(set.right) : 0) +
      (set.location.allow_direction && set.direction ? 1 : 0)
    );
  }

  function priceSet(set, index, products) {
    var lines = [];
    function add(key, label, detail, qty) {
      var p = product(products, key);
      lines.push({
        key: key,
        label: label,
        detail: detail || "",
        qty: qty || 1,
        price: p.price * (qty || 1),
      });
    }
    add(baseKey(set, index), set.location.name);
    if (set.location.allow_background && set.background && set.background !== "none")
      add("background", "Painted background", set.background.name || set.background);
    (set.location.allow_logos ? [set.left, set.right] : []).forEach(function (slot) {
      var type = logoType(slot);
      if (type)
        add(
          type === "custom" ? "customLogo" : "logo",
          type === "custom" ? "Custom logo tile" : "Design tile",
          slot.name + times(logoQty(slot)),
          logoQty(slot),
        );
    });
    if (set.location.allow_direction && set.direction) add("direction", "Direction tile", set.direction);
    return {
      lines: lines,
      total: lines.reduce(function (sum, line) {
        return sum + line.price;
      }, 0),
    };
  }

  function calculate(sets, products) {
    var priced = sets.map(function (set, i) {
      return priceSet(set, i, products);
    });
    return {
      sets: priced,
      total: priced.reduce(function (sum, set) {
        return sum + set.total;
      }, 0),
    };
  }

  function validate(sets, uploadLimits) {
    uploadLimits = uploadLimits || {};
    var errors = [];
    if (!sets.length || !sets[0].location)
      errors.push({
        path: "location",
        message: "Choose an installation location.",
      });
    sets.forEach(function (set, i) {
      var prefix = "sets." + i;
      if (!set.location) return;
      if (!/^\d{1,6}$/.test(String(set.number || "")))
        errors.push({
          path: prefix + ".number",
          message: "Enter a house number using 1–6 digits.",
        });
      if (set.location.kind === "plaque" && !set.mounting)
        errors.push({
          path: prefix + ".mounting",
          message: "Choose how the plaque will be mounted.",
        });
      if (set.location.max_tiles && tileCount(set) > set.location.max_tiles)
        errors.push({
          path: prefix + ".tiles",
          message: "This location fits up to " + set.location.max_tiles + " tiles.",
        });
      (set.location.allow_logos ? ["left", "right"] : []).forEach(function (side) {
        var slot = set[side];
        if (logoType(slot) === "custom" && !slot.file)
          errors.push({
            path: prefix + "." + side,
            message: "Choose a custom logo file.",
          });
      });
    });
    var files = [];
    sets.forEach(function (set) {
      (set.location.allow_logos ? ["left", "right"] : []).forEach(function (s) {
        if (set[s] && set[s].file) files.push(set[s].file);
      });
    });
    var perFile = ((uploadLimits && uploadLimits.perFileMB) || 10) * 1024 * 1024;
    var total = files.reduce(function (sum, file) {
      return sum + (file.size || 0);
    }, 0);
    files.forEach(function (file) {
      if (file.size > perFile)
        errors.push({
          path: "uploads",
          message: "Each file must be " + (uploadLimits.perFileMB || 10) + " MB or smaller.",
        });
    });
    if (total > 15 * 1024 * 1024)
      errors.push({
        path: "uploads",
        message: "All custom logo files together must be 15 MB or smaller.",
      });
    return errors;
  }

  function orderedProperties(set, index, group) {
    var p = {};
    p.Location = set.location.name;
    p["House number"] = String(set.number);
    p["Tile layout"] = tileLayout(set);
    if (set.location.allow_background)
      p.Background = set.background && set.background !== "none" ? set.background.name || set.background : "No paint";
    if (set.location.allow_logos && logoType(set.left)) p["Left logo"] = slotLabel(set.left) + times(logoQty(set.left));
    if (set.location.allow_logos && logoType(set.right))
      p["Right logo"] = slotLabel(set.right) + times(logoQty(set.right));
    if (set.location.allow_direction && set.direction) p["Direction tile"] = set.direction;
    if (set.location.kind === "plaque") p.Mounting = set.mounting;
    if (set.location.kind === "small_mailbox") p["Tile size"] = "1.625 in wide x 2 in tall";
    p._ao_group = group;
    p._ao_set = String(index + 1);
    p._ao_role = "set";
    return p;
  }

  function buildPayload(sets, products, group) {
    var items = [],
      details = { background: [], logo: [], direction: [] },
      logoTiles = 0,
      custom = [];
    sets.forEach(function (set, i) {
      var label = "Set " + (i + 1) + " (" + set.location.name + ")";
      items.push({
        id: product(products, baseKey(set, i)).id,
        quantity: 1,
        properties: orderedProperties(set, i, group),
      });
      if (set.location.allow_background && set.background && set.background !== "none")
        details.background.push(label + ": " + (set.background.name || set.background));
      (set.location.allow_logos ? ["left", "right"] : []).forEach(function (side) {
        var slot = set[side],
          type = logoType(slot),
          qty = logoQty(slot);
        if (type === "custom")
          custom.push({
            id: product(products, "customLogo").id,
            quantity: qty,
            file: slot.file,
            fileName: slot.file && slot.file.name,
            placement: "Set " + (i + 1) + " " + side,
            group: group,
          });
        else if (type) {
          details.logo.push(label + " " + side + ": " + slot.name + times(qty));
          logoTiles += qty;
        }
      });
      if (set.location.allow_direction && set.direction) details.direction.push(label + ": " + set.direction);
    });
    [
      ["background", "background"],
      ["logo", "logo"],
      ["direction", "direction"],
    ].forEach(function (pair) {
      var values = details[pair[0]];
      if (values.length)
        items.push({
          id: product(products, pair[1]).id,
          quantity: pair[0] === "logo" ? logoTiles : values.length,
          properties: {
            Details: values.join("; "),
            _ao_group: group,
            _ao_role: "addon",
          },
        });
    });
    return { customUploads: custom, items: items };
  }

  return {
    calculate: calculate,
    priceSet: priceSet,
    tileCount: tileCount,
    logoQty: logoQty,
    MAX_LOGO_QTY: MAX_LOGO_QTY,
    tileLayout: tileLayout,
    validate: validate,
    buildPayload: buildPayload,
    orderedProperties: orderedProperties,
  };
});
